import { CheckCircle2 } from "lucide-react";

const points = [
  "Industry-leading equipment & proven sanitation methods",
  "Environmentally responsible cleaning products",
  "Consistent quality with exceptional attention to detail",
  "Flexible daily, weekly & customized programs",
];

export const SeoContent = () => {
  return (
    <section data-testid="seo-content-section" className="py-24 sm:py-32 bg-[#f1f5f9]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <div>
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#e02329] mb-3">Your Trusted Partner</p>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-[#1c4f9c]">
            Commercial cleaning services you can depend on
          </h2>
          <p className="mt-5 text-base text-slate-600 leading-relaxed">
            Elite Facility Solutions is a trusted provider of commercial cleaning and facility support services. We specialize in creating customized cleaning programs for businesses seeking consistent quality, reliable service, and professional results.
          </p>
          <p className="mt-4 text-base text-slate-600 leading-relaxed">
            Whether you require daily janitorial services, weekly office cleaning, floor maintenance, or post-construction cleaning, our teams deliver professional results that keep your facility clean, safe, and presentable.
          </p>
          <ul className="mt-8 grid sm:grid-cols-2 gap-4">
            {points.map((p) => (
              <li key={p} className="flex items-start gap-3">
                <CheckCircle2 size={20} className="text-[#e02329] shrink-0 mt-0.5" />
                <span className="text-sm font-medium text-slate-700">{p}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="relative">
          <img
            src="https://images.pexels.com/photos/36631699/pexels-photo-36631699.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=700&w=940"
            alt="Clean modern office"
            loading="lazy"
            decoding="async"
            className="w-full h-[480px] object-cover rounded-sm shadow-xl"
          />
          <div className="absolute -bottom-6 -left-6 bg-[#e02329] text-white p-6 rounded-sm shadow-lg hidden sm:block">
            <p className="text-3xl font-extrabold font-display">100%</p>
            <p className="text-sm font-medium text-red-50">Satisfaction Focused</p>
          </div>
        </div>
      </div>
    </section>
  );
};
